enum BillOfLadingQuantityUnit {
	TON = 'tonnes',
	CUBIC = 'cubic_meters'
}

export default BillOfLadingQuantityUnit
